<template>
  <input
    type="text"
    :value="value"
    @keypress="handleKeyDown"
    @input="handleInput"
    ref="reference"
    @blur="$emit('blur')">
</template>
<script>

export default {
  name: 'AppNumberInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    reference: {
      type : String,
      default : ''
    }
  },
  methods: {
    handleKeyDown(event) {
      const key = event.key.toLowerCase();

      if (key === ',' || key === '.') {
        if (this.value.includes(',') || this.value.includes('.')) {
          event.preventDefault();
        }
      }

      if (key.match(/[\D]/g) && (key != ',' && key != '.')) {
        event.preventDefault();
      }
    },
    handleInput(event) {
      this.$emit('input', this.format(event.target.value));
    },
    format(value) {
      return value.replace(',', '.');
    }
  }
};
</script>
